import http from '@/assets/common/http';
// ----------------------------------采买单拉取数据
export function queryPurchase(data) {
  const params = {
    SERVICE_ID: '10022',
    OTYPE: 1,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------导出采买单数据
export function exportPurchase(data) {
  const params = {
    SERVICE_ID: '10022',
    OTYPE: 2,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------未分类产品大类名称
export function queryTitleFun(data) {
  const params = {
    SERVICE_ID: '10019',
    OTYPE: 5,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}
// ----------------------------------未分类产品
export function queryDataFun(data) {
  const params = {
    SERVICE_ID: '10008',
    OTYPE: 7,
    SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params);
}



// WEBPACK FOOTER //
// ./src/assets/api/purchaseOrder.js